import React from 'react'

export default function ExpirationsStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        #item-name {
          font-size: 0.95rem;
          padding: 10px;
          margin-bottom: 10px;
          font-weight: bold;
        }

        #expirations-container {
          display: flex;
          flex-direction: column;
          height: 100%;
        }

        #expiration-dates-container {
          font-size: 0.95rem;
          border: solid 1px green;
          background-color: lightgrey;
          margin-bottom: 10px;
          padding: 8px;
          height: 80%;
          overflow: auto;
        }

        .expiration-date {
          display: flex;
          border: solid 1px lightgrey;
          background-color: rgba(0, 0, 255, 1);
          margin-bottom: 3px;
          padding: 10px;
          color: whitesmoke;
          text-align: left;
          width: 100%;
        }
        /*.expiration-dates:hover {*/
        .expiration-date.active:hover {
          transform: scale(1.002);
          border-shadow: 2px 2px;
          color: white;
          background-color: rgba(0, 0, 230, 1);
        }
        .last-exp-date { margin-bottom: 0; }
        .expiration-date:disabled {
          color: lightgrey;
          opacity: 0.3;
        }

        #expiration-button-container {
          display: flex;
          justify-content: flex-end;
        }

        .check-mark-container {
          display: flex;
          justify-content: flex-end;
          flex: 1;
        }

        .check-mark {
          visibility: hidden;
          /*display: none;*/
          height: 20px;
          width: 20px;
          background-color: #028381;
          padding: 10px;
          border-radius: 50px;
          color: white;
          text-align: center;
        }
        .show-check-mark {
          /*display: block;*/
          visibility: visible;
        }

        #exp-date-btn-apply:disabled {
          color: lightgrey;
          opacity: 0.3;
        }
      `}
      </style>
    </React.Fragment>
  )
}
